import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { Profile } from '@widgets/dating/Profile';

const profileSearchSchema = z.object({
  canSwipes: z.boolean().optional(),
});

export const Route = createFileRoute('/dating/profile/$profileId')({
  component: RouteComponent,
  validateSearch: zodValidator(profileSearchSchema),
});

function RouteComponent() {
  const { profileId } = Route.useParams();
  const { canSwipes } = Route.useSearch();

  return <Profile profileId={profileId} canSwipes={canSwipes} />;
}
